module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag43_2054AT.1ed8d890.jpg";